import React, { useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { api } from "../../services/api.js";
import Swal from "sweetalert2";
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";

export default function ImportadorPrecos() {
    const [uploading, setUploading] = useState(false);
    const [workbook, setWorkbook] = useState(null);
    const [abas, setAbas] = useState([]);
    const [abaSelecionada, setAbaSelecionada] = useState("");
    const [dadosParaExibir, setDadosParaExibir] = useState([]);
    const [tipoImportacao, setTipoImportacao] = useState("promocao"); // 'promocao' ou 'segmento'
    const fileInputRef = useRef(null);

    // Configuração de colunas esperadas
    const colunasEsperadas = {
        promocao: [
            "PROM_USUARIO", "PROM_LOJA", "PROM_INICIO", "PROM_FIM",
            "PROM_DESCRICAO", "PROM_GRUPO", "PROM_CODIGO",
            "PROM_SEGMENTO", "PROM_STATUS", "PROM_PRECO"
        ],
        segmento: [
            "PREC_DATA", "PREC_LOJA", "PREC_CODIGO", "PREC_PRECO"
        ]
    };

    const mostrarLoading = (titulo, texto) => {
        return Swal.fire({
            title: titulo,
            text: texto,
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => { Swal.showLoading(); }
        });
    };

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        mostrarLoading('Lendo Arquivo', 'Aguarde o processamento inicial...');

        setTimeout(() => {
            const reader = new FileReader();
            reader.onload = (evt) => {
                try {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, { type: 'binary' });
                    setWorkbook(wb);
                    setAbas(wb.SheetNames);
                    setAbaSelecionada("");
                    setDadosParaExibir([]);
                    Swal.close();
                } catch (err) {
                    Swal.fire("Erro", "Falha ao ler planilha.", "error");
                }
            };
            reader.readAsBinaryString(file);
        }, 100);
    };

    const handleSelecaoAba = (e) => {
        const nomeAba = e.target.value;
        setAbaSelecionada(nomeAba);

        if (nomeAba) {
            mostrarLoading('Processando Guia', 'Validando estrutura e formatando dados...');

            setTimeout(() => {
                const ws = workbook.Sheets[nomeAba];

                // AJUSTE AQUI: Adicionamos cellDates, dateNF e raw
                const rawData = XLSX.utils.sheet_to_json(ws, {
                    defval: "",
                    raw: false,      // MUITO IMPORTANTE: raw: false faz o XLSX ler o texto da célula, não o valor bruto
                    dateNF: 'dd/mm/yyyy' // Força o formato brasileiro na leitura
                });

                if (rawData.length === 0) {
                    Swal.fire("Aviso", "A aba selecionada está vazia.", "warning");
                    return;
                }

                // Limpa nomes das colunas e valida se as necessárias existem
                const colunasArquivo = Object.keys(rawData[0]).map(k => k.trim());
                const obrigatorias = colunasEsperadas[tipoImportacao];

                const faltantes = obrigatorias.filter(col => !colunasArquivo.includes(col));

                if (faltantes.length > 0) {
                    Swal.fire("Erro de Estrutura", `Faltam as colunas: ${faltantes.join(", ")}`, "error");
                    setAbaSelecionada("");
                    return;
                }

                const cleanData = rawData.map(row => {
                    const newRow = {};
                    Object.keys(row).forEach(key => {
                        const trimmedKey = key.trim();
                        let value = row[key];

                        if (trimmedKey === 'PREC_DATA') {
                            if (typeof value === 'number') {
                                const date = XLSX.SSF.parse_date_code(value);

                                // Se a biblioteca inverteu, date.m virou 9 e date.d virou 5
                                // Mas a sua planilha é 09/05. 
                                // Vamos usar uma lógica de detecção simples ou forçar a ordem da planilha
                                let dia = String(date.d).padStart(2, '0');
                                let mes = String(date.m).padStart(2, '0');
                                const ano = date.y;

                                // SE o seu console.log mostra 05/09 e você quer 09/05, inverta aqui:
                                value = `${mes}/${dia}/${ano}`;
                            }
                            else if (typeof value === 'string' && value.includes('/')) {
                                const partes = value.split('/');
                                // Garante DD/MM/YYYY mesmo que a string venha bagunçada
                                const p1 = partes[0].padStart(2, '0');
                                const p2 = partes[1].padStart(2, '0');
                                let ano = partes[2];
                                if (ano.length === 2) ano = '20' + ano;

                                // Se chegar 5/9 e você sabe que é 9/5, inverta a ordem das variáveis p1 e p2 abaixo:
                                value = `${p2}/${p1}/${ano}`;
                            }
                        }

                        newRow[trimmedKey] = value;
                    });
                    return newRow;
                });

                setDadosParaExibir(cleanData);
                Swal.close();
            }, 100);
        } else {
            setDadosParaExibir([]);
        }
    };

    const processarEnvio = async () => {
        if (dadosParaExibir.length === 0) return;

        const rota = tipoImportacao === 'promocao' ? '/preco/promocao' : '/preco/segmento';
        const label = tipoImportacao === 'promocao' ? 'Promoção' : 'Preço Segmento';

        const { isConfirmed } = await Swal.fire({
            title: 'Confirmar Importação',
            text: `Deseja importar ${dadosParaExibir.length} registros para ${label}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, importar'
        });

        if (!isConfirmed) return;

        setUploading(true);

        Swal.fire({
            title: 'Sincronizando com Servidor',
            html: 'Progresso: <b>0%</b>',
            allowOutsideClick: false,
            didOpen: () => { Swal.showLoading(); }
        });

        const TAMANHO_LOTE = 500;
        const total = dadosParaExibir.length;

        try {
            for (let i = 0; i < total; i += TAMANHO_LOTE) {
                const lote = dadosParaExibir.slice(i, i + TAMANHO_LOTE);
                const progresso = Math.round((i / total) * 100);

                if (Swal.getHtmlContainer()) {
                    Swal.getHtmlContainer().querySelector('b').textContent = `${progresso}%`;
                }

                await api.post(rota, lote);
            }

            Swal.fire("Sucesso", `Importação de ${label} concluída!`, "success");
            setDadosParaExibir([]);
            setAbas([]);
            setAbaSelecionada("");
            setWorkbook(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        } catch (error) {
            Swal.fire("Erro", "Falha na comunicação com o servidor.", "error");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="d-flex flex-column min-vh-100 bg-white">
            <Menu modulo="PROMO" />
            <main className="flex-grow-1 d-flex flex-column" style={{ marginTop: '60px' }}>
                <div className="border-bottom bg-light px-3 py-2">
                    <div className="row g-2 align-items-center">

                        {/* Seletor de Tipo */}
                        <div className="col-auto">
                            <select
                                className="form-select form-select-sm fw-bold border-primary"
                                value={tipoImportacao}
                                onChange={(e) => {
                                    setTipoImportacao(e.target.value);
                                    setDadosParaExibir([]); // Limpa ao trocar tipo
                                    setAbaSelecionada("");
                                }}
                                disabled={uploading || abas.length > 0}
                            >
                                <option value="promocao">IMPORTA PROMOÇÃO</option>
                                <option value="segmento">IMPORTA PREÇO SEGMENTO</option>
                            </select>
                        </div>

                        <div className="col-auto">
                            <input type="file" id="fileInput" className="d-none" accept=".xlsx, .xls" ref={fileInputRef} onChange={handleFile} />
                            <button className="btn btn-sm btn-outline-secondary fw-bold" onClick={() => document.getElementById('fileInput').click()} disabled={uploading}>
                                <i className="fas fa-file-excel me-2"></i>Escolher Planilha
                            </button>
                        </div>

                        {abas.length > 0 && (
                            <div className="col-auto d-flex align-items-center">
                                <span className="small me-2 fw-bold text-danger">Guia:</span>
                                <select className="form-select form-select-sm border-danger" style={{ width: '200px' }} value={abaSelecionada} onChange={handleSelecaoAba} disabled={uploading}>
                                    <option value="">Selecione a aba...</option>
                                    {abas.map(n => <option key={n} value={n}>{n}</option>)}
                                </select>
                            </div>
                        )}

                        {dadosParaExibir.length > 0 && (
                            <div className="col-auto ms-auto">
                                <button className="btn btn-sm btn-success fw-bold" onClick={processarEnvio} disabled={uploading}>
                                    <i className="fas fa-sync me-2"></i>Sincronizar {dadosParaExibir.length} itens
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex-grow-1 overflow-hidden d-flex flex-column">
                    {dadosParaExibir.length > 0 ? (
                        <div className="table-responsive flex-grow-1">
                            <table className="table table-sm table-hover table-striped mb-0" style={{ fontSize: '0.75rem' }}>
                                <thead className="table-dark sticky-top">
                                    <tr>
                                        {Object.keys(dadosParaExibir[0]).map(key => (
                                            <th key={key} className="px-2 py-1 text-uppercase border-end border-secondary">{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {dadosParaExibir.map((item, idx) => (
                                        <tr key={idx}>
                                            {Object.values(item).map((val, i) => (
                                                <td key={i} className="px-2 py-1 text-nowrap border-end">{String(val)}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="m-auto text-center text-muted">
                            <i className="fas fa-file-import fa-3x mb-3 opacity-25"></i>
                            <p>Selecione o tipo de importação e carregue o arquivo.</p>
                            <div className="badge bg-info text-dark">
                                Modo: {tipoImportacao === 'promocao' ? 'Promoção' : 'Preço Segmento'}
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
}